import React, { useState } from 'react';
import { useWizard } from '../../../../../components/wizard/WizardContext';
import StudentDetails from '../../multiTypeRefund/selectRefundItems/StudentDetails';
import { studentDetailsLabelFieldMapping, useCheckForRefundEdit } from '../../multiTypeRefund/utils';
import { useGetCompletionRefundStep2Data } from '../utils';
import RefundAccountsCard from '../../multiTypeRefund/selectRefundAccounts/RefundAccountsCard';
import ALoader from '../../../../../views/pages/manage/common/a-loader';
import { getInitialChequeDetails } from '../../multiTypeRefund/selectRefundAccounts';
import EyeIcon from "assets/img/svg/svgComponents/EyeIcon";
import { useNavigateToGivenPath } from '../../../../../views/pages/manage/edpOps/studentDetails/paymentSummary/service';
import { REFUND_MANAGE_ACCOUNTS } from '../../../../../views/pages/manage/edpOps/studentDetails/constant';
import Footer from '../../../../studentTransfer/components/Footer';
import AButton from '../../../../../views/pages/manage/common/form-fields-mui/AButton';
import { useSaveDataToConfigValues } from '../../rectificationRefund/selectRefundReasonAndReceipt/utils';
import moment from 'moment';
import { Tooltip } from '@mui/material';
import InfoIconSolid from "assets/img/svg/svgComponents/InfoIconSolid";
import useValidateStdOutView from '../../../../../hooks/useValidateStdOutView';

const RefundChequeDateLabel = () => {
    return (
        <>
            <span>Refund Cheque Date*</span>
            <Tooltip title={"The date cannot be set before the course start date, nor can it be more than six months from today."}>
                <span className='ml-1'><InfoIconSolid color="black" /></span>
            </Tooltip>
        </>
    )
}


const SelectCompletionRefundPaymode = () => {

    const { values, dropdowns, setValues, next } = useWizard();
    const forRefundEdit = useCheckForRefundEdit();
    const { selectedStudent, completionRefundStep2Data = {}, completionRefundUtils, raisedRefundDetails } = values;
    const { psid } = selectedStudent;

    const [loading, setLoading] = useState(false);
    const [chequeDetailsForm, setChequeDetailsForm] = useState(() => getInitialChequeDetails({ raisedRefundDetails, forRefundEdit, stepData: completionRefundStep2Data }));


    const { studentAccountDetails = [], payableRefundInfo, coursePricingDetails } = completionRefundStep2Data;


    const primaryStudentAccount = chequeDetailsForm?.chequeDetailsSaved ? chequeDetailsForm : studentAccountDetails?.find(details => details?.accountType === 'Primary' && details?.bankStatus === 'ACTIVE');

    const navigateToGivenPath = useNavigateToGivenPath();


    useGetCompletionRefundStep2Data({ setLoading });

    const manageAccountsClickHandler = () => {
        navigateToGivenPath(`admin/edp/studentDetails/${psid}?source=${REFUND_MANAGE_ACCOUNTS}`);
        setValues(vals => ({
            ...vals,
            completionRefundStep2Data: {
                ...vals?.completionRefundStep2Data,
                studentAccountDetails: []
            }
        }))
        next(0);

    }

    const dataToSaveToConfig = {
        selectedStudentAppId: selectedStudent?.applicationId,
        primaryStudentAccount
    }

    console.log('completionRefundStep2Data', completionRefundStep2Data);

    useSaveDataToConfigValues(dataToSaveToConfig, "completionRefundStep2Data");

    const { checkingStdOutValidity } = useValidateStdOutView({
        bu: selectedStudent?.businessAreaDispVal,
        psid: selectedStudent?.psid,
        applicationId: selectedStudent?.applicationId
    })


    return (
        <div className='d-flex flex-column m-2' style={{ gap: '1rem' }}>
            {(checkingStdOutValidity || loading) && <ALoader position={"fixed"} />}

            <StudentDetails
                studentDetails={selectedStudent}
                labelFieldMappings={studentDetailsLabelFieldMapping(selectedStudent, dropdowns?.data)}
            />

            <RefundAccountsCard
                accountDetails={[...studentAccountDetails, chequeDetailsForm]}
                multiTypeRefundUtils={completionRefundUtils}
                title={"Student Refund Accounts"}
                manageAccountsClickHandler={manageAccountsClickHandler}
                openDetailsDialogIcon={<EyeIcon />}
                amount={payableRefundInfo?.totalRefundableAmount}
                primaryStudentAccount={primaryStudentAccount}
                setChequeDetailsForm={setChequeDetailsForm}
                chequeDetailsFormFieldsConfig={{
                    chequeDate: {
                        minDate: coursePricingDetails?.courseStartDate,
                        maxDate: moment(new Date()).add(6, "months"),
                        label: <RefundChequeDateLabel />
                    }
                }}
            />

            <Footer>
                <div>Choose a paymode</div>
                <AButton
                    onClick={() => next()}
                    className="button_remove_left_margin"
                    variant="primary_filled"
                    disabled={!primaryStudentAccount}
                >
                    Proceed Next
                </AButton>
            </Footer>
        </div>


    );
}

export default SelectCompletionRefundPaymode;